<script lang="ts">
	import { ALL_STORIES_ID } from '#lib/features/news/components/NewsCardGrid/constants.js';
	import { NewsCardGrid } from '#lib/features/news/components/NewsCardGrid/index.js';

	interface Props {
		articles:
			| Array<{
					id: string;
					title?: string | null;
					description?: string | null;
					image?: string;
					categories?: string[];
					geotag?: { name: string } | null;
					artists?: Array<
						| { HENI_News_Artists_id?: { name?: string } | null }
						| null
						| undefined
					>;
					url?: string | null;
					attribution?: string | null;
					date_created?: string | null;
					date_updated?: string | null;
					publishDate?: string | null;
			  }>
			| undefined;
		loading: boolean;
		onClick: () => void;
	}

	let { articles, loading, onClick }: Props = $props();
</script>

<div id={ALL_STORIES_ID}>
	<NewsCardGrid
		{articles}
		classes={{
			container: 'pt-4 lg:pt-12 sm:hidden',
		}}
		{loading}
		{onClick}
		widgetMode="column"
		showCharts={false}
		showProfileCharts
	/>

	<NewsCardGrid
		{articles}
		classes={{
			container: 'pt-4 lg:pt-12 hidden sm:block',
		}}
		{loading}
		{onClick}
		widgetMode="classic"
		showCharts={false}
		showProfileCharts
	/>
</div>
